import * as React from "react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { STEP_KEY as GROUP_SYNC_KEY } from "components/authentication/directoryServices/BackendWizard/GroupSyncStep";
import EditLinkButton from "components/authentication/directoryServices/BackendConfigDetails/EditLinkButton";
import { Spinner } from "components/common";
import { ButtonToolbar } from "components/bootstrap";
import SectionComponent from "components/common/Section/SectionComponent";
import GroupSyncDetails from "./GroupSyncDetails";
import TriggerTeamSyncResponse from "./TriggerTeamSyncResponse";
import TriggerTeamSyncButton from "../TriggerTeamSyncButton";
import { loadGroupSync } from "../../api/groupSync";
const GroupSyncSection = ({
  authenticationBackend: { id: backendId, title: backendTitle },
  roles,
  excludedFields = void 0
}) => {
  const { t } = useTranslation("enterprise_authentication");
  const [groupSyncBackend, setGroupSyncBackend] = useState();
  const [finishedLoading, setFinishedLoading] = useState(false);
  const [triggerSyncResponse, setTriggerSyncResponse] = useState();
  useEffect(() => {
    loadGroupSync(backendId).then((result) => {
      if (result && result.backend) {
        setGroupSyncBackend(result.backend);
      }
      setFinishedLoading(true);
    }).catch(() => {
      setFinishedLoading(true);
      setGroupSyncBackend(void 0);
    });
  }, [backendId]);
  if (!finishedLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: t("directory_services.group_sync_section.title"),
      headerActions: /* @__PURE__ */ React.createElement(ButtonToolbar, null, groupSyncBackend && /* @__PURE__ */ React.createElement(
        TriggerTeamSyncButton,
        {
          backendId,
          backendTitle,
          setResponse: setTriggerSyncResponse
        }
      ), /* @__PURE__ */ React.createElement(EditLinkButton, { authenticationBackendId: backendId, stepKey: GROUP_SYNC_KEY }))
    },
    /* @__PURE__ */ React.createElement(GroupSyncDetails, { groupSyncBackend, roles, excludedFields }),
    triggerSyncResponse && /* @__PURE__ */ React.createElement(TriggerTeamSyncResponse, { response: triggerSyncResponse })
  );
};
export default GroupSyncSection;
